// extracted by mini-css-extract-plugin
module.exports = {"wqgfllr":"wqgfllr","lpt47mw":"lpt47mw"};